import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ListGroup, Button, Form, Row, Col } from 'react-bootstrap';

const ModuleList = () => {
    const [modules, setModules] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [newModule, setNewModule] = useState({ nom: '', type: '', volume_horaire: '' });

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/modules`)
            .then(res => setModules(res.data))
            .catch(err => console.log(err));
    }, []);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleInputChange = (e) => {
        setNewModule({ ...newModule, [e.target.name]: e.target.value });
    };

    const handleAddModule = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/modules`, newModule)
            .then(res => setModules([...modules, res.data]))
            .catch(err => console.log(err));
    };

    const handleDeleteModule = (id) => {
        axios.delete(`${process.env.REACT_APP_API_URL}/api/modules/${id}`)
            .then(() => setModules(modules.filter(module => module.id !== id)))
            .catch(err => console.log(err));
    };

    const filteredModules = modules.filter(module =>
        module.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
        module.type.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div>
            <h2 className="mt-4">Ajouter un module</h2>
            <Form as={Row} className="mb-4">
                <Col>
                    <Form.Control type="text" name="nom" placeholder="Nom du module" onChange={handleInputChange} />
                </Col>
                <Col>
                    <Form.Control type="text" name="type" placeholder="Type" onChange={handleInputChange} />
                </Col>
                <Col>
                    <Form.Control type="number" name="volume_horaire" placeholder="Volume horaire" onChange={handleInputChange} />
                </Col>
                <Col>
                    <Button onClick={handleAddModule}>Ajouter</Button>
                </Col>
            </Form>

            <h2 className="mt-4">Liste des modules</h2>
            <Form.Control type="text" placeholder="Rechercher..." className="mb-3" onChange={handleSearch} />
            <ListGroup>
                {filteredModules.map(module => (
                    <ListGroup.Item key={module.id}>
                        <Link to={`/modules/${module.id}`}>{module.nom}</Link> ({module.type} - {module.volume_horaire}h)
                        <Button variant="danger" size="sm" className="float-end" onClick={() => handleDeleteModule(module.id)}>Supprimer</Button>
                    </ListGroup.Item>
                ))}
            </ListGroup>
        </div>
    );
};

export default ModuleList;